import { NgModule } from '@angular/core';

import { PickupForCheckoutModule } from './forCheckout';
import { PickupForCurrentLocationModule } from './forCurrentLocation';
import { PickupForFilterModule } from './forFilter';
import { PickupForHeroModule } from './forHero';
import { PickupForScheduleModule } from './forSchedule';
import { PickupForScheduleMockModule } from './forScheduleMock';

const toExport: any[] = [
    PickupForCheckoutModule,
    PickupForCurrentLocationModule,
    PickupForFilterModule,
    PickupForHeroModule,
    PickupForScheduleModule,
    PickupForScheduleMockModule,
];

@NgModule({
    imports: [
        ...toExport
    ],
    exports: [
        ...toExport
    ],
})
export class PickupTypesModule { }
